import { rawHttp } from '../http';
import endpointConfig from '../config/endpointConfig';
import { CaInfo, isCaInfo } from '../entities/ca-info';

type CaInfoResponse = {
	code: string;
	data: CaInfo[];
};

export async function getCaInfo(): Promise<CaInfo[]> {
	const response = await rawHttp.get<CaInfoResponse>(
		endpointConfig.caInfo,
	);

	const list = response.data?.data ?? [];
	if (!Array.isArray(list) || !list.every(isCaInfo)) {
		throw new TypeError('Invalid CA info response');
	}
	return list;
}
